import { type AddressType } from '@garnish/location';

import { OrderType } from '@sg/graphql-schema';

import { useDerivedRateOrderStatus } from '../useDerivedRateOrderStatus';

// ─────────────────────────────────────────────────────────────────────────────

export const useMomosOrder = (params: UseMomosOrderParams) => {
  const { order } = params;

  if (!order) return undefined;

  const orderId = order.id;
  const orderTime = order.wantedTime;
  const orderType = toAddressType(order.orderType, order.isOutpost);
  const restaurantEntityId = order.restaurantEntityId;

  return {
    orderId,
    orderTime,
    orderType,
    restaurantEntityId,
  };
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function toAddressType(orderType: OrderType, isOutpost: boolean): AddressType | undefined {
  switch (orderType) {
    case OrderType.Pickup:
      return isOutpost ? 'outpost' : 'pickup';
    case OrderType.Delivery:
      return 'delivery';
    case OrderType.InStore:
      return 'in-store';
    default:
      return undefined;
  }
}

// ─── Types ───────────────────────────────────────────────────────────────────

type UseMomosOrderParams = {
  order: ReturnType<typeof useDerivedRateOrderStatus>['order'];
};
